import React from "react";
export default class Product extends React.Component {
  imgList = [
    {
      src: require("../assets/images/product/hh.jpg"),
      name: "黄鹤",
      title: "伊百丽 河西技术院长",
      p1: "执业证书编号：141430000303939",
      p2: "擅长领域：面部综合抗衰及微整",
    },

    {
      src: require("../assets/images/product/lj.jpg"),
      name: "刘建",
      title: "伊百丽 含浦院技术院长",
      p1: "执业证书编号：110430104002046",
      p2: "擅长领域：微整形注射、",
      p3: "皮肤的诊断和治疗、",
      p4: "面部年轻化等",
    },
    {
      src: require("../assets/images/product/lw.jpg"),
      name: "林雯",
      title: "伊百丽 星沙院技术院长",
      p1: "执业证书编号：110430102001704",
      p2: "擅长领域：艺术化微整形注射、",
      p3: "5S综合医学美肤管理、",
      p4: "面部抗衰老等",
    },
    {
      src: require("../assets/images/product/mfs.jpg"),
      name: "闵发胜",
      title: "伊百丽 金源技术院长",
      p1: "执业证书编号：110430103002525",
      p2: "擅长领域：微整形注射、",
      p3: "皮肤的诊断和治疗、",
      p4: "面部年轻化等",
    },
    {
      src: require("../assets/images/product/olc.jpg"),
      name: "欧利春",
      title: "伊百丽 汇金院技术院长",
      p1: "执业证书编号：110431022198503241064",
      p2: "擅长领域：激光美肤、",
      p3: "各类色斑治疗、",
      p4: "面部抗衰老等",
    },

    {
      src: require("../assets/images/product/ygh.jpg"),
      name: "银贵华",
      title: "伊百丽 阳光院技术院长",
      p1: "执业证书编号：110430523198007120020",
      p2: "擅长领域：皮肤色素性疾病、",
      p3: "线雕抗衰、",
      p4: "微整注射等",
    },

    {
      src: require("../assets/images/product/zm.jpg"),
      name: "周敏",
      title: "伊百丽 西子院技术院长",
      p1: "执业证书编号：110430700004613",
      p2: "擅长领域：面部年轻化、",
      p3: "5S皮肤年轻化管理、",
      p4: "美容治疗等",
    },
    {
      src: require("../assets/images/product/hyw.jpg"),
      name: "何玉文",
      title: "伊百丽 技术院长",
    },
    {
      src: require("../assets/images/product/lhr.jpg"),
      name: "刘华荣",
      title: "伊百丽 技术院长",
    },
    {
      src: require("../assets/images/product/zcc.JPG"),
      name: "周春香",
      title: "伊百丽 技术院长",
    },
    {
      src: require("../assets/images/product/xry.jpg"),
      name: "徐瑞迎",
      title: "伊百丽 技术院长",
    },
    {
      src: require("../assets/images/product/zsh.jpg"),
      name: "曾烁虎",
      title: "伊百丽 技术院长",
    },
  ];
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="content">
        {/* <div>
          <a>
            <img
              src="http://nb.isbelle.com.cn/uploads/images/jstd.jpg"
              alt=""
            />
          </a>
        </div>

        <div>
          <a>
            <img
              src="http://nb.isbelle.com.cn/uploads/images/1-20092Z94503-50.jpg"
              alt=""
            />
          </a>
        </div>

        <div>
          <a>
            <img
              src="http://nb.isbelle.com.cn/uploads/images/1-20092Z94503-51.jpg"
              alt=""
            />
          </a>
        </div> */}

        {/* <div>
          <a>
            <img
              src="http://nb.isbelle.com.cn/uploads/images/1-20092Z94503-52.jpg"
              alt=""
            />
          </a>
        </div> */}

        {/* <div>
          <a>
            <img
              src="http://nb.isbelle.com.cn/uploads/images/1-20092Z94503-53.jpg"
              alt=""
            />
          </a>
        </div> */}

        <div className="h80"></div>
      </div>
    );
  }
}
